import { Grid, styled, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import CustomButton from "../../components/Components/Button";
import DatePicker from "react-datepicker";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  getGuestReport,
  getKeysReport,
  getMaterialInwardReport,
  getMaterialOutwardReport,
  getMaterialReturnableReport,
  getMilkReport,
  getVechileReport,
} from "./mutations/ReportsMutation";
import { handleToastMsg } from "../../components/Components/Toast";
import CustomDivider from "../../components/Components/CustomDivider"

const StyledDatePicker = styled(DatePicker)`
padding: 8px 10px;
  border: 1px solid gray; 
  border-radius: 5px; 
  width: 100%;
`;

function ReportsDownload({ setStepper, module, showBack = false }) {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);


  // YYYY-MM-DD in the browser's local timezone. Converting via UTC
  // (JSON.stringify) shifted IST dates back by one day.
  const getDate = (date) => {
    const d = new Date(date);
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  // Backend sends either a plain string or { message } / { error }
  const getErrorMessage = (err) => {
    const data = err?.response?.data;
    if (typeof data === "string" && data) return data;
    return data?.message || data?.error || err.message;
  };

  const reportByModule = {
    MILK: getMilkReport,
    GUESTS: getGuestReport,
    VECHILE: getVechileReport,
    MATERIAL_INWARD: getMaterialInwardReport,
    MATERIAL_OUTWARD: getMaterialOutwardReport,
    KEYS: getKeysReport,
  };

  const handleDownload = async () => {
    // compare calendar days only; the default dates also carry the current time
    if (getDate(endDate) < getDate(startDate)) {
      handleToastMsg("'To' date must be on or after 'From' date", "error");
      return;
    }
    const fetchReport = reportByModule[module] || getMaterialReturnableReport;
    try {
      setIsLoading(true);
      await fetchReport({
        fromDate: getDate(startDate),
        toDate: getDate(endDate),
      });
    } catch (err) {
      console.log({ err });
      handleToastMsg(getErrorMessage(err), "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Grid container justifyContent={"center"} width={"100%"} >
      <Grid item xs={12} container>
        {showBack && (
          <Grid
            item
            xs={2}
            onClick={() => setStepper("REPORTS")}
            style={{ cursor: "pointer" }}
          >
            <ArrowBackIcon />
          </Grid>
        )}
        <Grid item xs={8} contianer textAlign={"center"}  >
          <h4>Download {module.toLowerCase()} Reports</h4>
        </Grid>
        <CustomDivider />
      </Grid>

      <Grid
        item
        container
        xs={12}
        marginTop={5}
        // direction={"row"}
        // minHeight={250}
        overflow={'hidden'}
        justifyContent={"center"}
        style={{ paddingTop: '3%', paddingBottom: '20%' }}
      >
        <Grid item container xs={4} justifyContent={"center"} alignItems={'center'}>
          <Grid item xs={2}>
            From
          </Grid>
          <Grid item >
            <StyledDatePicker
              selected={startDate}
              dateFormat="dd/MM/yyyy"
              onChange={(date) => setStartDate(date)}
            />
          </Grid>
        </Grid>

        <Grid item container xs={4} justifyContent={"center"} alignItems={'center'}>
          <Grid item xs={1}>
            To
          </Grid>
          <Grid item>
            <StyledDatePicker
              selected={endDate}
              dateFormat="dd/MM/yyyy"
              onChange={(date) => setEndDate(date)}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item contianer style={{ paddingBottom: '4%' }}>
        {/* {isLoading ? <CustomButton onClick={handleDownload}><CircularProgress /></CustomButton> : <CustomButton onClick={handleDownload}>Download Report</CustomButton>} */}
        {/* <CustomButton onClick={handleDownload}>Download Report</CustomButton> */}
        <CustomButton onClick={handleDownload}>{isLoading ? <CircularProgress size={26} style={{ color: 'white' }} /> : "Download Report"}</CustomButton>
      </Grid>
    </Grid>
  );
}

export default ReportsDownload;
